function resizeBefAft(){
    if($(document).width() >= 2034){
        $('.before_after_slider, .before_after_slider>div>img').css('width', '1400px');
        $('.before_after_slider, .before_after_slider>div>img').css('height', '973px');
    }else if($(document).width() >= 1749){
        $('.before_after_slider, .before_after_slider>div>img').css('width', '1200px');
        $('.before_after_slider, .before_after_slider>div>img').css('height', '834px');
    }else if($(document).width() >= 1349){
        $('.before_after_slider, .before_after_slider>div>img').css('width', '920px');
        $('.before_after_slider, .before_after_slider>div>img').css('height', '639px');
    }else{
        $('.before_after_slider, .before_after_slider>div>img').css('width', '600px');
        $('.before_after_slider, .before_after_slider>div>img').css('height', '417px');
    }
}
function zoomer(){
    $('#zoom').anythingZoomer();
}
function befAftData(){
    img_width = $('.black_white img').width();
    init_split = Math.round(img_width/2);
}


function sidebarMenu(elem){
    $('.side-menu a').removeClass('actual');
    elem.addClass('actual');
    var itemsCount = elem.parents('li').index();
    $('.side-menu-wrapper li').removeClass('previous');
    $('.menu-position').height(51*(itemsCount - 2));
    for(var sMenu=2; sMenu <= itemsCount; sMenu++){
        $('.side-menu-wrapper li:nth-of-type(' + sMenu + ')').addClass('previous');
    }
}


function closeSlider(){
    $('#about-video-layer-1').removeClass('full');
    $('.book').removeClass('go');
    $('#da-slider .da-arrows-prev, #da-slider .da-arrows-next, .skip-slider').fadeOut();
    $('header, body').removeClass('header-hide');
    if (!$('html').hasClass('tablet portrait')) {
        $('.enter-cbw').fadeIn();
    }
    $('.dive-close').fadeOut();
    $('.addthis-smartlayers').show();
    $('#da-slider .da-dots span:first-child').click();
}

function loadImages(){
    var loadedImages = 0;
    function checkAllLoaded(){
        if( loadedImages >= 4 ){
            $('.new-loading-wrap').css('display', 'none');
            $('#zoom-row').css('display', 'block');
            $('#bf-slider-container').css('display', 'block');
            $('#after-bf-slider-text').css('display', 'block');
            $('#zoom').anythingZoomer();
        }
    }
    $("<img/>").attr("src", 'new_img/zoom-p.jpg').load(function(){
        $('#zoom img').attr('src', 'new_img/zoom-p.jpg');
        loadedImages += 1;
        checkAllLoaded();
    });
    $("<img/>").attr("src", 'new_img/aft.jpg').load(function(){
        $('#ba_after').attr('src', 'new_img/aft.jpg');
        loadedImages += 1;
        checkAllLoaded();
    });
    $("<img/>").attr("src", 'new_img/bef.jpg').load(function(){
        $('#ba_before').attr('src', 'new_img/bef.jpg');
        loadedImages += 1;
        checkAllLoaded();
    });
    $("<img/>").attr("src", 'new_img/bef-af-fon.jpg').load(function(){
        $('#ba_fullsize').attr('src', 'new_img/bef-af-fon.jpg');
        loadedImages += 1;
        checkAllLoaded();
    });
    function addVideoToPage(videoName, id, blockId){
        $('#'+blockId).html('<video id="video-slide'+id+'" muted="muted" loop>'+
                                        '<source src="video/'+videoName+'.mp4" type="video/mp4" class="vmp4">'+
                                        '<source src="video/'+videoName+'.ogv" type=\'video/ogg; codecs="theora, vorbis"\' class="vogv">'+
                                        '<source src="video/'+videoName+'.webm" type=\'video/webm; codecs="vp8, vorbis"\' class="vwebm">'+
                                      '</video>');
    }
    $("<img/>").attr("src", 'new_img/new-main_about_page-min.png').load(function(){
        addVideoToPage('hypnos', '1', 'about-video-layer-1');
        document.getElementById('video-slide1').play();
        document.getElementById('video-slide1').addEventListener('loadeddata', function() {
            addVideoToPage('gotm', '2', 'pog-2 > .da-img');
            addVideoToPage('brave', '3', 'pog-3 > .da-img');
            addVideoToPage('Spyder', '4', 'pog-4 > .da-img');
        }, false);
    });
}


$(document).ready(function(){
    var menuHeight = $('header').height();

    var slideWidth=320;
    var sliderTimer;

    //about page
    $('#da-slider .da-arrows-next').click(function () {
        setTimeout(function () {
            // skip slider if first block is current
            if ($('#da-slider>div:first-child').hasClass('da-slide-current')) {
                $('header, body').removeClass('header-hide');
                $('.book').removeClass('go');
                if (!$('html').hasClass('tablet portrait')) {
                    $('.enter-cbw').fadeIn();
                }
                $('#da-slider .da-arrows-prev, #da-slider .da-arrows-next, .skip-slider').fadeOut();
                $('body').addClass('second-transition always-transition move-buttons').removeClass('first-time');
            }
        }, 500);
        playNextVideo();
    });

    $('#da-slider .da-arrows-prev').click(function () {
        playPrevVideo();
    });

    $(function(){
        $('.slidewrapper').width($('.slidewrapper').children().length *slideWidth);
        sliderTimer=setInterval(nextSlide,3000);
        $('.viewport').hover(function(){
            clearInterval(sliderTimer);
        },function(){
            sliderTimer=setInterval(nextSlide,3000);
        });
    });

    function nextSlide(){
        var currentSlide=parseInt($('.slidewrapper').data('current'));
        currentSlide++;
        if(currentSlide>=$('.slidewrapper').children().length)
        {
            currentSlide=0;
        }
        $('.slidewrapper').animate({left: -currentSlide*slideWidth},300).data('current',currentSlide);
    }
    //видео в слайдере вверху страницы

    $(document).on('click','.fullsize', function(event){
        event.stopPropagation();
        // $(window).trigger('gallery.fullscreen');
        $('.before_after_slider').toggleClass('fullscreen');
        $('body').toggleClass('before-after-fon');
        $('.about-center.bf').toggleClass('zindex');
        $('.side-menu, .side-menu-substrate').toggleClass('hideall');
        if($('.before_after_slider').hasClass('fullscreen')) {
            $('.fullscreen, .fullscreen>div>img').css('width', $(window).width());
            $('.fullscreen>div>img').css('height', 'auto');

            setTimeout(function(){
                $('.fullscreen').css('height',  $('.fullscreen>div>img').height());
                if( $('.fullscreen>div>img').height() > $(window).height()){
                    $('.before_after_slider').css('height', $(window).height());
                }
            }, 100);
        }else if($(document).width() >= 2034) {
            $('.before_after_slider, .before_after_slider>div>img').css('width', '1400px');
            $('.before_after_slider, .before_after_slider>div>img').css('height', '973px');
            $('.before_after_slider .black_white').css('width', '700px');
            $('.ba-circle').css('left',$('.black_white img').width() / 2 - 26);
        }else if($(document).width() >= 1749){
                $('.before_after_slider, .before_after_slider>div>img').css('width', '1200px');
                $('.before_after_slider, .before_after_slider>div>img').css('height', '834px');
            $('.before_after_slider .black_white').css('width', '600px');
            $('.ba-circle').css('left',$('.black_white img').width() / 2 - 26);
        }else if($(document).width() >= 1349){
            $('.before_after_slider, .before_after_slider>div>img').css('width', '920px');
            $('.before_after_slider, .before_after_slider>div>img').css('height', '639px');
            $('.before_after_slider .black_white').css('width', '460px');
            $('.ba-circle').css('left',$('.black_white img').width() / 2 - 26);
        }else{
            $('.before_after_slider, .before_after_slider>div>img').css('width', '600px');
            $('.before_after_slider, .before_after_slider>div>img').css('height', '417px');
            $('.before_after_slider .black_white').css('width', '300px');
            $('.ba-circle').css('left',$('.black_white img').width() / 2 - 26);
        }
        img_width = $('.black_white img').width();
        init_split = Math.round(img_width/2);

    });

    resizeBefAft();


    // Мой плагин до и после
    var $black_white = $('.black_white'),
        img_width = $('.black_white img').width(),
        init_split = Math.round(img_width/2);

    var bf_slider = document.getElementById('bf_slider');

    $black_white.width(init_split);
    $('.ba-circle').css('left',init_split-26);

    $('.before_after_slider').mousemove(function(e){
        var offX  = (e.clientX - $black_white.offset().left);
            $black_white.width(offX);
            $('.ba-circle').css('left', offX - 26);
    });

    bf_slider.addEventListener('touchmove', function(event) {
        var x = event.touches[0].pageX - (($(window).width() - img_width)/2);

        if(x < img_width && x > 0) {
            $black_white.width(x);
            $('.ba-circle').css('left', x - 26);
        }
    }, false);

    // ======================================== //
    zoomer();

    // $(window).on('load', function () {
    //     zoomer();
    // });

    $(window).on('resize',  function() {
        img_width = $('.black_white img').width();
        init_split = Math.round(img_width/2);

        $black_white.width(init_split);
        $('.ba-circle').css('left',init_split-26);
        zoomer();
        if ($('.before_after_slider').hasClass('fullscreen')){
            $('.fullsize').click();
        }
        resizeBefAft();
    });    

    $('.side-menu-wrapper li a').each(function(){
        var link = $(this).attr('href');
        var lastPart = link.substring(link.indexOf('#'));

        $(this).attr('href', lastPart);
    });

    $('.side-menu a').bind("click", function(e){

        sidebarMenu($(this));

        var anchor = $(this);
        var name = anchor.attr('href').replace(new RegExp("#",'gi'), '');
        $('html, body').stop().animate({
            scrollTop: $('a[id='+name+']').offset().top - menuHeight
        }, 1000);
        window.location.hash = name;
        e.preventDefault();
        return false;
    });

    $(window).scroll(function() {
        if ($(window).scrollTop() == 0){
            $('.side-menu, .side-menu-substrate').fadeOut();
        }
        if ($(window).scrollTop() > 0) {
//            $('.logo').addClass('anim');
            $('.side-menu').fadeIn().css('display','table');
            $('.side-menu-substrate').css('display', 'table-cell');
        }

        $('.go-link').each(function() {
            if($(this).offset().top - ($(window).height() * 0.35) < $(window).scrollTop()){
                var myAtrrLink = $(this).attr('id');
                //last = myAtrrLink;
                sidebarMenu($('.side-menu-wrapper li a[href="#'+myAtrrLink+'"]'));
            }
        });


        // video slider top about page
        $('.about-slider-header-text').css('display', 'block');
        $('.side-menu, .side-menu-substrate').removeClass('hide-v-menu');

        if($(window).scrollTop() === 0 ){
            $('body').addClass('always-transition');
            /* $('header').addClass('header-hide'); */
        }

        if($('header').hasClass('header-hide') && $(window).scrollTop() > 0 ){
            $('body').removeClass('always-transition').addClass('trasition-to-top');
            closeSlider();

            var firstVideoId = $('#da-slider .da-slide-current video').attr("id");
            var firstVideo = document.getElementById(firstVideoId);
            if (firstVideoId != null) {
                firstVideo.pause();
            }
        }
    });

    $(document).on('mouseenter', '.slider-wrapper-f', function () {
        $('.side-menu').fadeOut();
    });
    $(document).on('mouseleave', '.slider-wrapper-f', function () {
        $('.side-menu').fadeIn().css('display','table');
    });

    function dive(){
        daSliderInitialize();
        playFirstVideo();
        $('#about-video-layer-1').addClass('full');
        $('#da-slider .da-arrows-prev, #da-slider .da-arrows-next, .skip-slider').fadeIn();
        $('.book').addClass('go').removeClass('mouse-scroll');
        $('body').addClass('header-hide');
        $('header').addClass('header-hide');
        $('body').addClass('header-hide');
        $('.dive-close').fadeIn();
        $('.addthis-smartlayers').hide();
//        $(this).fadeOut();
        setTimeout(function(){
            $('#da-slider .da-arrows-next').addClass('allow');
        },2000);
        //playFirstVideo();
        $('.about-slider-header-text').css('display', 'none');
        $('#side-menu-about, .side-menu-substrate').css('display', 'none');

    }

    //Кнопка Enter CINE-BOOKS World
    $(document).on('click','.enter-cbw', function(){
        if( $(window).scrollTop() > 0 ){
            $('html,body').animate({scrollTop: 0}, 1000, dive);
        } else {
            dive();
        }
    });

    function closeDive(){
        closeSlider();
        $('body').addClass('second-transition always-transition move-buttons').removeClass('first-time');
        $('html').scrollTop(0);
        $('a[href=#features]').click();

        $('#da-slider .da-arrows-prev, #da-slider .da-arrows-next').fadeOut();
        $('.about-slider-header-text').css('display', 'block');
        $('.dive-close').fadeOut();
        $('.side-menu-substrate').css('display', 'table-cell');
    }

    //Кнопка Skip, close
    $(document).on('click', '.skip-slider, .dive-close', function () {
        closeDive();
    });

    $(document).keydown(function(e) {
        // ESCAPE dive key pressed
        if (e.keyCode == 27) {
            closeDive();
        }
    });

    $('.fullsize').on('click', function(){
        $('header').fadeToggle();
    });

    $('.skip-slider').on('click', function(){
        $('.about-slider-header-text').css('display', 'block');
        document.getElementById('video-slide1').play();
    });

    loadImages();
    $('html').addClass('about-page');

    if( window.location.hash.length > 0 ){
        setTimeout(function () {
            $('#side-menu-about a[href="'+window.location.hash+'"]').eq(0).click();
        }, 500);
    }

});
